/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tree': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<g _fill="#C4FFF9" fill-rule="nonzero"><path pid="0" d="M70 46h6v65h-6zM46 40h58v6H46z"/><path pid="1" d="M70 105h35v6H70z"/><path pid="2" d="M104 90h35v35h-35V90zm5 5v25h25V95h-25zM104 25h35v35h-35V25zm5 5v25h25V30h-25zM12 25h35v35H12V25zm5 5v25h25V30H17z"/></g>'
  }
})
